//

((_document) => {
    console.log(_document.querySelector('html'))
})(document)